export default __webpack_public_path__ + "static/2-e1dfc7e8bdd4ef85d34f83f196f87831.jpeg";